import { TealiumConstants } from '../constants/tealium.constants';

/**
 * @description PortfolioAnalyserAnalyticsConfig: contains the configuration for start and completion events for the  360-evaluator-tool.
 */

export const PortfolioAnalyserAnalyticsConfig = [
	{
		id: 'generate-ps-advisor-report',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.DOWNLOAD,
				eventNumber: 'event53',
				linkName: TealiumConstants.TOOLS_EVENT.PS_ADVISOR_PDF
			}
		],
		description: 'Fires, when the user clicks generate advisor report',
		rules: [],
		pageName: null
	},
	{
		id: 'find-a-model',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'find a model',
				legacyFlow: 'new analysis'
			}
		],
		description: 'Fires when a user clicks on the new find a model button. path: new-analysis.component.html',
		rules: ['startEventRule'],
		pageName: null
	},
	{
		id: 'find-a-model-complete',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'find a model',
				legacyFlow: 'new analysis'
			}
		],
		description: 'Fires when a user clicks on the new view button. path: new-analysis.component.html -> Find A Model Modal path.',
		rules: ['completeEventRule'],
		pageName: null
	},
	{
		id: 'create-new',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'create new',
				legacyFlow: 'new analysis'
			}
		],
		description: 'Fires when a user clicks on the create new button. path: new-analysis.component.html',
		rules: ['startEventRule'],
		pageName: null
	},
	{
		id: 'create-new-complete',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'create new',
				legacyFlow: 'new analysis'
			}
		],
		description: 'Fires when a user clicks on the new view button. path: new-analysis.component.html -> Create New Modal path.',
		rules: ['completeEventRule'],
		pageName: null
	},
	{
		id: 'my-portfolios',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'my portfolios',
				legacyFlow: 'new analysis'
			}
		],
		description: 'Fires when a user clicks on the my portfolios button. path: new-analysis.component.html',
		rules: ['startEventRule'],
		pageName: null
	},
	{
		id: 'my-portfolios-complete',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'my portfolios',
				legacyFlow: 'new analysis'
			}
		],
		description: 'Fires when a user clicks on the new view button. path: new-analysis.component.html -> My Portfolios Modal path.',
		rules: ['completeEventRule'],
		pageName: null
	},
	{
		id: 'import-partner-portfolio',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'import portfolios',
				legacyFlow: 'new analysis'
			}
		],
		description: 'Fires when a user clicks on the import portfolios button. path: new-analysis.component.html',
		rules: ['startEventRule'],
		pageName: null
	},
	{
		id: 'import-partner-portfolio-complete',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'import portfolios',
				legacyFlow: 'new analysis'
			}
		],
		description: 'Fires when a user clicks on the new view button. path: new-analysis.component.html -> Import Portfolios Modal path.',
		rules: ['completeEventRule'],
		pageName: null
	},
	{
		id: 'view',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'find a model'
			},
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 Evaluator - ',
				toolFlow: 'find a model'
			}
		],
		description: 'Fires, when the user gets to the results; path: 360-evaluator-tool',
		rules: ['deepLinkRule'],
		pageName: 'view'
	},
	{
		id: 'analysis/overview',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			},
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			}
		],
		description: 'Fires, when the user deep links to the results; path: overview',
		rules: ['deepLinkRule'],
		pageName: 'overview'
	},
	{
		id: 'analysis/peer-comparison',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			},
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			}
		],
		description: 'Fires, when the user deep links to the results; path: peer-comparison',
		rules: ['deepLinkRule'],
		pageName: 'peer-comparison'
	},
	{
		id: 'analysis/characteristics',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			},
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			}
		],
		description: 'Fires, when the user gets to the results; path: characteristics',
		rules: ['deepLinkRule'],
		pageName: 'characteristics'
	},
	{
		id: 'analysis/performance',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			},
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			}
		],
		description: 'Fires, when the user gets to the results; path: performance',
		rules: ['deepLinkRule'],
		pageName: 'performance'
	},
	{
		id: 'analysis/decoding-risk',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			},
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			}
		],
		description: 'Fires, when the user gets to the results; path: decoding-risk',
		rules: ['deepLinkRule'],
		pageName: 'decoding-risk'
	},
	{
		id: 'analysis/scenario-analysis',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			},
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			}
		],
		description: 'Fires, when the user gets to the results; path: scenario-analysis',
		rules: ['deepLinkRule'],
		pageName: 'scenario-analysis'
	},
	{
		id: 'analysis/commentary',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			},
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			}
		],
		description: 'Fires, when the user gets to the results; path: commentary',
		rules: ['deepLinkRule'],
		pageName: 'commentary'
	},
	{
		id: 'analysis/insights',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			},
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			}
		],
		description: 'Fires, when the user gets to the results; path: insights',
		rules: ['deepLinkRule'],
		pageName: 'insights'
	},
	{
		id: 'analysis/holdings-characteristics',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			},
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			}
		],
		description: 'Fires, when the user gets to the results; path: holdings-characteristics',
		rules: ['deepLinkRule'],
		pageName: 'holdings-characteristics'
	},
	{
		id: 'analysis/esg',
		events: [
			{
				eventName: TealiumConstants.TOOLS_EVENT.START,
				eventNumber: 'event2',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			},
			{
				eventName: TealiumConstants.TOOLS_EVENT.COMPLETION,
				eventNumber: 'event3',
				linkName: '360 evaluator - ',
				toolFlow: 'deep link'
			}
		],
		description: 'Fires, when the user gets to the results; path: esg',
		rules: ['deepLinkRule'],
		pageName: 'esg'
	}
];
